import request from '@/utils/request'

//上传七牛云获取token

export function getUploadToken(params) {
    return request({
        url: '/app/getUploadToken',
        method: 'get',
        params,
    })
}
export function getShortLink(params) {
    return request({
        url: '/app/getShortLink',
        method: 'get',
        params,
    })
}

//系统相关api
//获取内部员工
export function roleFindList(params) {
    return request({
        url: '/role/findList',
        method: 'get',
        params,
    })
}

//更新楼房
export function updateApp(data) {
    return request({
        url: '/super/updateApp',
        method: 'post',
        data,
    })
}

// 重置密码销售系统   重置员工密码 /role/updatePassword 参数 password
export function updatePassword(data) {
    return request({
        url: '/role/updatePassword',
        method: 'post',
        data,
    })
}

// 获取小程序码
export function findCode(params) {
    return request({
        url: '/app/findCode',
        method: 'get',
        params,
    })
}
// 获取终端列表
//clientAppId
export function findEndpointList(params) {
    return request({
        url: '/super/findEndpointList',
        method: 'get',
        params,
    })
}